import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import get from 'lodash/get';
import Ad from '../ad/ad';
import FCLink from '../fc_link/fc_link';
import asyncPostNativeAdActions from '../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../redux/action_creators/ads_action_creator';

const tempSponsoredArticles = [
  {
    image:
      'https://images.fastcompany.net/image/upload/wp-cms/uploads/2019/09/SAP_Why-entrepreneurs-need-a-diverse-media-diet.jpg',
    eyebrow: 'PRESENTED BY SAP',
    title: 'Why entrepreneurs need a diverse media diet',
    url:
      'https://www.fastcompany.com/90407798/why-entrepreneurs-need-a-diverse-media-diet'
  },
  {
    image:
      'https://images.fastcompany.net/image/upload/wp-cms/uploads/2019/11/SAP-Article-8-Image-.jpg',
    eyebrow: 'PRESENTED BY SAP',
    title: '3 Ways User Stories And Personas Lead To Deeper Engagement',
    url:
      'https://www.fastcompany.com/90431925/3-ways-user-stories-and-personas-lead-to-deeper-engagement'
  },
  {
    image:
      'https://images.fastcompany.net/image/upload/wp-cms/uploads/2014/10/SAP_SyndArticle_Customer-Experience-Gap.jpg',
    eyebrow: 'PRESENTED BY SAP',
    title: 'Magic Happens When Companies Close the Customer Experience Gap',
    url:
      'https://www.fastcompany.com/90423278/magic-happens-when-companies-close-the-customer-experience-gap'
  }
];

class Megatron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      activeNative: true,
      // sponsoredCardData: null,
      tempSponsoredCardData: null
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.swiperResize = this.swiperResize.bind(this);
  }

  componentWillMount() {
    // random 0 - 2
    const randomSponorCard = Math.floor(Math.random() * 3);
    this.setState({
      tempSponsoredCardData: tempSponsoredArticles[randomSponorCard]
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.swiperResize);
  }

  componentWillReceiveProps(nextProps) {
    const nativeAdHomepageTileLoaded = get(
      nextProps,
      'adsLoaded.native_homepagefeature'
    );

    if (nativeAdHomepageTileLoaded) {
      this.setNativeAd();
      this.props.dispatchAdLoadedEvent('native_homepagefeature', false);
    }

    const newPostNativeAd = get(
      nextProps,
      'postNativeAd.homepageFeaturedTile.posts'
    );

    if (
      get(newPostNativeAd, 'length') !==
        get(this.props, 'postNativeAd.homepageFeaturedTile.posts.length') &&
      get(newPostNativeAd, 'length')
    ) {
      this.setState({
        // sponsoredCardData: newPostNativeAd
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.swiperResize);
  }

  onMouseEnter(index) {
    this.setState({ activeIndex: index });
    this.swiper.slideTo(index);
    this.swiper.autoplay.stop();
  }

  onMouseLeave() {
    this.swiper.autoplay.start();
  }

  setNativeAd() {
    const nativeAdsData = get(window, 'fc_ads.native.homepageFeaturedTile');

    if (!nativeAdsData) {
      return;
    }

    // Check if it's native_type === homepageFeaturedTile
    if (get(nativeAdsData, 'native_type') === 'homepageFeaturedTile') {
      if (
        !get(nativeAdsData, 'article_ids') &&
        !get(nativeAdsData, 'campaign_name') &&
        !get(nativeAdsData, 'clickthrough_url')
      ) {
        return;
      }

      this.props.dispatchPostNativeAd(nativeAdsData, get(this.props, 'config'));
    }
  }

  swiperResize() {
    this.swiper.update();
  }

  render() {
    const { activeIndex, activeNative, tempSponsoredCardData } = this.state;
    const { articles, config, combinedAdModel } = this.props;
    const settings = {
      effect: 'fade',
      autoplay: {
        delay: 4000
      },
      on: {
        slideChangeTransitionStart: () => {
          const { activeIndex: ai } = this.swiper;
          if (ai === 2 && activeNative) {
            this.setState({
              activeNative: false
            });
          }
          this.setState({ activeIndex: ai });
        }
      }
    };

    return (
      <Fragment>
        <div className="megatron">
          <Swiper
            {...settings}
            ref={node => {
              if (node) this.swiper = node.swiper;
            }}
          >
            {articles.map(({ featured_image: img }) => (
              <div key={img.source} className="megatron__slide">
                <div
                  className="megatron__slide-background"
                  style={{ backgroundImage: `url(${img.source})` }}
                />
              </div>
            ))}
          </Swiper>
          <div className="megatron__articles">
            {articles.map(({ title, categories, link }, index) => (
              <article
                key={link}
                className={`megatron__article ${
                  activeIndex === index ? 'megatron__article--active' : ''
                }`}
                onMouseEnter={() => this.onMouseEnter(index)}
                onMouseLeave={this.onMouseLeave}
              >
                <FCLink title={title} to={link} config={config}>
                  {categories.map(({ name }) => <span key={name}>{name}</span>)}
                  <h2>{title}</h2>
                </FCLink>
              </article>
            ))}
            {tempSponsoredCardData && (
              <div
                className={`megatron__article megatron__article--native ${
                  activeNative ? 'megatron__article--native__active' : ''
                }`}
              >
                <a href={tempSponsoredCardData.url}>
                  <div className="img-container">
                    <img
                      src={tempSponsoredCardData.image}
                      alt={tempSponsoredCardData.title}
                    />
                  </div>
                  <span>{tempSponsoredCardData.eyebrow}</span>
                  <h2>{tempSponsoredCardData.title}</h2>
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="homepage-page__ff-ad-container">
          <Ad {...combinedAdModel} name="flexiblebillboard_2" />
        </div>
      </Fragment>
    );
  }
}

Megatron.propTypes = {
  config: PropTypes.shape({}).isRequired,
  articles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired
};

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    postpage: state.postpage,
    postNativeAd: get(state, 'postNativeAd.data', {}),
    adsLoaded: get(state, 'ads.data')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Megatron);
